export default __webpack_public_path__ + "static/home_bodegon_chile-0e1026eab62d29897ff0010587ef7894.png";